export function getUrlParam(paraName) {
	let url = document.location.toString();
	let arrObj = url.split("?");

	if (arrObj.length > 1) {
		let arrPara = arrObj[1].split("&");
		let arr;

		for (let i = 0; i < arrPara.length; i++) {
			arr = arrPara[i].split("=");

			if (arr != null && arr[0] == paraName) {
				return arr[1];
			}
		}
		return "";
	} else {
		return "";
	}
}
export function debounce(func, wait, immediate = true) {
	let timeout = null
	return function() {
		if (timeout) clearTimeout(timeout)
		timeout = setTimeout(() => {
			func.apply(this, arguments, wait)
		})
	}
}
export function throttle(func, wait, trailing) {
	let timer = null
	let start = 0
	return function() {
		let now = new Date()
		let remaining = wait - (now - start)
		// 拦截：延迟时间>多次点击间隔时间，执行：多次点击间隔时间>延迟时间
		if ((now - start) >= wait) {
			// 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔
			// 但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
			timer && clearTimeout(timer)
			timer = null
			start = now
			return func()
		} else if (!timer && trailing) {
			// trailing有值时，延时执行func函数
			// 频繁操作，第一次设置定时器之后，之后的不会再走到这里创建定时器
			// 清除问题，只能在第二有效点击的时候才会清除
			timer = setTimeout(() => {
				timer = null
				return func
			}, wait)
		}
	}
}
//设置cookie
export function setCookie(c_name, c_pwd, exdays) {
	var exdate = new Date(); //获取时间
	exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
	//字符串拼接cookie
	// c_name = Base64.encode(c_name)
	// c_pwd = Base64.encode(c_pwd)

	document.cookie = "userName" + "=" + c_name + ";expires=" + exdate.toGMTString();
	document.cookie = "userPwd" + "=" + c_pwd + ";expires=" + exdate.toGMTString();
	console.log(document.cookie)
}
//读取cookie
export function getCookie() {
	let obj = {}
	if (document.cookie.length > 0) {
		var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
		for (var i = 0; i < arr.length; i++) {
			var arr2 = arr[i].split('='); //再次切割
			//判断查找相对应的值
			if (arr2[0] == 'userName') {
				obj.username = arr2[1]; //保存到保存数据的地方
			} else if (arr2[0] == 'userPwd') {
				obj.password = arr2[1];
			}
		}
	}
	return obj
}
//清除cookie
export function clearCookie() {
	setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
}
